<template lang="pug">

v-app
    v-app-bar(app)
        v-toolbar-items
            v-btn(to="/" text nuxt x-large) Synodic Software
    v-content
        router-view
    v-footer(app)
        v-spacer
        small Copyright &copy; {{ new Date().getFullYear() }} -
            strong &nbsp;Synodic Software, LLC
        v-spacer

</template>

<script>

export default {
    name: 'App',

    data: () => ({
        //
    })
};

</script>
